import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {ProductPriority} from '../../models/product-priority/product-priority';

@Injectable({
  providedIn: 'root'
})
export class ProductPriorityService extends AbstractModelService<ProductPriority> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/product-priority', ProductPriority);
  }
}
